import { render, staticRenderFns } from "./AuthorizerCreate.vue?vue&type=template&id=3c4b33ae&"
import script from "./AuthorizerCreate.vue?vue&type=script&lang=js&"
export * from "./AuthorizerCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports